export const DEFAULT_MAX_PAGE_BUTTONS = 3;

export const DEFAULT_RESULTS_PER_PAGE_OPTIONS = [
  { label: '25 results', value: 25 },
  { label: '50 results', value: 50 },
  { label: '100 results', value: 100 },
  { label: '200 results', value: 200 },
];
